import React, { FC, useEffect, useState } from 'react';
import { Control, FieldErrors, UseFormRegister, UseFormSetValue, useWatch } from 'react-hook-form';

import { RadioButtons } from '@eika/radio-button';

import { Omsorgsansvar } from '../../generated-types';
import { useTranslation } from '../../translations';
import { BarnFormData } from './barn';

interface Props {
    index: number;
    register: UseFormRegister<BarnFormData>;
    control: Control<BarnFormData>;
    setValue: UseFormSetValue<BarnFormData>;
    errors: FieldErrors<BarnFormData>;
}

const Foreldreansvar: FC<Props> = ({ index, register, control, setValue, errors }) => {
    const { barn, validationMessage } = useTranslation();
    const value = useWatch({ name: 'barn', control });
    const [omsorgsansvar, setOmsorgsansvar] = useState<Omsorgsansvar>(value?.[index]?.omsorgsansvar);

    useEffect((): void => {
        register(`barn.${index}.omsorgsansvar` as const, {
            validate: { ikkeValgt: (value) => value !== Omsorgsansvar.IKKE_VALGT },
        });
    }, [register, index, validationMessage]);

    const onChangeOmsorgsansvar = (value: Omsorgsansvar) => {
        setValue(`barn.${index}.omsorgsansvar`, value, {
            shouldValidate: true,
        });
        setOmsorgsansvar(value);
    };

    return (
        <RadioButtons
            label={barn.radioTitleForeldreansvar}
            options={[
                { value: Omsorgsansvar.FULLT, label: barn.radioFullOmsorg },
                {
                    value: Omsorgsansvar.DELT,
                    label: barn.radioDeltOmsorg,
                },
                {
                    value: Omsorgsansvar.INGEN,
                    label: barn.radioIngenOmsorg,
                },
            ]}
            selectedOption={omsorgsansvar}
            errorMessage={
                errors.barn?.[index]?.omsorgsansvar?.type === 'ikkeValgt' ? `${validationMessage.requiredChoose}` : ''
            }
            onChange={(value) => onChangeOmsorgsansvar(value as Omsorgsansvar)}
        />
    );
};

export default Foreldreansvar;
